$(document).ready(function () {
	initIonRangeSlider();
});

function initIonRangeSlider() {
	var $range = $('.price-filter-range');
	var $inputFrom = $('.price-filter-min-price');
	var $inputTo = $('.price-filter-max-price');
	var instance;
	var min = $range.data('min');
	var max = $range.data('max');
	var prefix = $range.data('prefix');
	var from = $inputFrom.val() ? $inputFrom.val() : 0;
	var to = $inputTo.val() ? $inputTo.val() : max;

	$range.ionRangeSlider({
		skin: 'round',
		type: 'double',
		min: min,
		max: max,
		from: from,
		to: to,
		grid: false,
		prefix: prefix,
		hide_min_max: true,
		hide_from_to: false,
		onChange: updateInputs,
		onFinish: updateInputs,
	});

	instance = $range.data('ionRangeSlider');

	function updateInputs(data) {
		from = data.from;
		to = data.to;

		setValueAndDispatch($inputFrom[0], from);
		setValueAndDispatch($inputTo[0], to);
	}

	function setValueAndDispatch(input, value) {
		if (input.value == value) return;

		input.value = value;

		input.dispatchEvent(
			new Event('input', {
				bubbles: true,
				cancelable: true,
			}),
		);
	}

	$inputFrom.on('change', function () {
		var val = $(this).prop('value');
		if (val < min) {
			val = min;
		} else if (val > to) {
			val = to;
		}
		instance.update({
			from: val,
		});
		$(this).prop('value', val);
		$('.slider-range--btn').trigger('click');
	});

	$inputTo.on('change', function () {
		var val = $(this).prop('value');
		if (val < from) {
			val = from;
		} else if (val > max) {
			val = max;
		}
		instance.update({
			to: val,
		});
		$(this).prop('value', val);
		$('.slider-range--btn').trigger('click');
	});
}
